import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { Subject } from '../../models/subject';


@Injectable({
  providedIn: 'root'
})
export class SubjectService {
  api_url = environment.apiUrl;
  casched_subject: Observable<Subject | Partial<Subject>>;

  constructor(private http: HttpClient) { }

  clearCache() {
    this.casched_subject = null;
  }

  getSubjectList(params: any) {
    return this.http.get(this.api_url + '/subjects', { params: params })
  }

  getSubject(uuid: string) {
    if (!this.casched_subject) {
      this.casched_subject = this.http.get(this.api_url + '/subjects/' + uuid).pipe(
        map((response: any) => response["data"]),
        shareReplay()
      );
    }
    return this.casched_subject;
  }

  patchSubject(uuid: string, subject: any): Observable<Partial<Subject> | Subject> {
    return this.http.patch(this.api_url + '/subjects/' + uuid + '/', subject).pipe(
      map((response: any) => response["data"])
    );
  }

  postSubject(subject: any): Observable<Partial<Subject> | Subject> {
    return this.http.post(this.api_url + '/subjects/', subject).pipe(
      map((response: any) => response["data"])
    );
  }

  deleteSubject(subject: any): Observable<any> {
    return this.http.delete(this.api_url + '/subjects/' + subject.uuid);
  }

  getOperatedList(params?: any): Observable<any> {
    return this.http.get(this.api_url + '/operated-subjects', { params: params });
  }

  getExportResultFile(ext: string, params?: any): Observable<Blob> {
    const requestParams = { ...(params || {}), ext };
    return this.http.get(this.api_url + '/operated-subjects/export', { params: requestParams, responseType: 'blob' });
  }

  getBailiffsList(): Observable<any> {
    return this.http.get(this.api_url + '/operated-subjects/bailiffs');
  }

  getWhiteIpsList(uuid: string): Observable<any> {
    return this.http.get(this.api_url + `/subjects/white_ips_list?sub_uuid=${uuid}`);
  }

  addIpToWhiteList(uuid: string, ip: string): Observable<any> {
    return this.http.post(this.api_url + `/subjects/white_ips_list/`, { sub_uuid: uuid, ip: ip });
  }

  deleteIpToWhiteList(id: number): Observable<any> {
    return this.http.delete(this.api_url + `/subjects/white_ips_list/?id=${id}`);
  }

  public getSubjectByTempCode(params: any): Observable<any> {
    return this.http.post(this.api_url + '/operated-subjects/temp-codes/resolve/', params);
  }

  addOperatedSubjects(subjects: any[]): Observable<any> {
    return this.http.post(this.api_url + '/operated-subjects/add/', subjects);
  }

  removeFromOperatedList(list: any[]): Observable<any> {
    return this.http.post(this.api_url + '/operated-subjects/', list);
  }

  public getTempRelationCode(nip_regon: string): Observable<any> {
    return this.http.post(`${this.api_url}/operated-subjects/temp-codes/`, { identity: nip_regon });
  }

  public getLastActivityPeriods(params: any): Observable<any> {
    return this.http.get(`${this.api_url}/import/plugins`, { params: params });
  }
  public getActiveSubjectPlugin(subject_uuid: any): Observable<any> {
    return this.http.get(`${this.api_url}/import/${subject_uuid}/pluginsActivity`);
  }

  public getActivityPeriods(params: any): Observable<any> {
    return this.http.get(`${this.api_url}/import/periods/history`, { params: params });
  }

  public getSubjectByNipRegon(lookup: string): Observable<any> {
    return this.http.post(`${this.api_url}/operated-subjects/by-nip-regon/`, { lookup: lookup });
  }

}
